import api from './index'
import { axios } from '@/utils/request'

export function getFastDFSToken () {
  return axios({
    url: api.GetFastDFSToken,
    method: 'get'
  })
}

export function saveFileUrl (params) {
  return axios({
    url: api.SaveFileUrl,
    method: 'post',
    params: params
  })
}

export function fetchFileUrl (params) {
  return axios({
    url: api.FetchFileUrl,
    method: 'get',
    params: params
  })
}
